module.exports = __webpack_public_path__ + "static/media/Piercing-nose-nostril.909710ad.png";